import { render, staticRenderFns } from "./SenseOfWorth.vue?vue&type=template&id=23d4d1ae&"
import script from "./SenseOfWorth.vue?vue&type=script&lang=js&"
export * from "./SenseOfWorth.vue?vue&type=script&lang=js&"
import style0 from "./SenseOfWorth.vue?vue&type=style&index=0&id=23d4d1ae&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports